import axiosInstance from '@/utils/api.js'

var state = {
  paymentMethods: []
}

var getters = {
  PAYMENT_METHODS: (state) => {
    return state.paymentMethods
  }
}

var mutations = {
  SET_PAYMENT_METHODS: (state, payload) => {
    state.paymentMethods = payload
  }
}

var actions = {
  GET_PAYMENT_METHODS: async (context, payload) => {
    let result = await axiosInstance.get('/referencebooks/paymentmethods')
    if (result.status === 200) {
      context.commit('SET_PAYMENT_METHODS', result.data)
    }
  },
  CREATE_PAYMENT_METHODS: (context, payload) => {
    return axiosInstance.post('/referencebooks/paymentmethods', payload)
  },
  UPDATE_PAYMENT_METHODS: (context, payload) => {
    return axiosInstance.put('/referencebooks/paymentmethods', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/referencebooks/paymentMethods.js